Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    cardBackgroundColor: tokens.themeBackgroundAlternatePrimaryDefault,
    cardBackgroundColorDefault: tokens.themeBackgroundAlternatePrimaryDefault,
    cardBackgroundColorDisabled: tokens.themeBackgroundPrimaryDisabled,
    cardBackgroundColorPressed: tokens.themeBackgroundAlternatePrimarySelected,
    cardBorderWidth: 1,
    cardBorderRadius: 4,
    cardBorderColor: tokens.themeBorderTertiaryDefault,
    cardSpacingInset: 32,
    cardSpacingVertical: 16,
    cardDropShadowDefaultOffsetX: 0,
    cardDropShadowDefaultOffsetY: 2,
    cardDropShadowDefaultBlur: 4,
    cardDropShadowDefaultSpread: 0,
    cardDropShadowDefaultColor: "rgba(11, 12, 12, 0.16)",
    cardDropShadowHoverOffsetX: 0,
    cardDropShadowHoverOffsetY: 4,
    cardDropShadowHoverBlur: 8,
    cardDropShadowHoverSpread: 0,
    cardDropShadowHoverColor: "rgba(11, 12, 12, 0.16)",
    cardDropShadowPressedOffsetX: 0,
    cardDropShadowPressedOffsetY: 3,
    cardDropShadowPressedBlur: 6,
    cardDropShadowPressedSpread: 0,
    cardDropShadowPressedColor: "rgba(11, 12, 12, 0.16)",
    cardOffsetVerticalDefault: 0,
    cardOffsetVerticalHover: -4,
    cardOffsetVerticalPressed: -2
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian-tokens/component/card.js
// module id = 139
// module chunks = 0